import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-econ-help',
  templateUrl: './econ-help.component.html',
  styleUrls: ['./econ-help.component.css']
})
export class EconHelpComponent implements OnInit {

  constructor(public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  openDialog() {
    const dialogRef = this.dialog.open(EconHelpDialogContent, {
      width: '50%',
    });
  }
}

@Component({
  selector: 'econ-help-dialog-content',
  templateUrl: 'econ-help-dialog-content.html'
})

export class EconHelpDialogContent {

}
